import Keycloak from "keycloak-js";

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_CLIENT_URL || "/auth",
  realm: process.env.REACT_APP_KEYCLOAK_CLIENT_REALM || "lepinoc",
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_CLIENT_ID || "frontend",
});

export default keycloak;
